import { parseHtmlToValue, serialize } from 'core-components/library/richTextEditor'

export const preparingTagsForNewEditorHTML = (htmlText: string) => {
  const deserializedValue = parseHtmlToValue({ value: htmlText })

  const serializedValue = deserializedValue.map((item) => serialize(item)).join('')

  const addParagraph = !serializedValue.endsWith('</p>')
    ? serializedValue + '<p></p>'
    : serializedValue

  return addParagraph
}
